import { Grid, Stack, Box, Checkbox, Autocomplete, TextField, Typography } from '@mui/material'
import { useEffect } from 'react'

const EditAssignedTemplates = ({ widgetStructures, designTemplatesDataTheme, selectedTemplates, setSelectedTemplates, singlePageContent }: any) => {

    useEffect(() => {
        if (singlePageContent?.templates) {
            const newSelectedTemplates = widgetStructures.reduce((acc: any, widget: any) => {
                const foundTemplate = singlePageContent.templates?.find(
                    (template: any) => template.component === widget.name
                );
                return {
                    ...acc,
                    [widget.name]: foundTemplate?.shared_uid || null
                };
            }, {});
            setSelectedTemplates(newSelectedTemplates);
        }
    }, [singlePageContent, widgetStructures, setSelectedTemplates]);

    const getTemplatesForWidget = (widgetName: string) => {
        return designTemplatesDataTheme
            ?.filter((template: any) => template.component === widgetName)
            .map((template: any) => ({
                value: template.shared_uid,
                label: template.name,
            })) || [];
    };

    const handleTemplateChange = (name: string, newValue: any) => {
        setSelectedTemplates((prev: any) => ({
            ...prev,
            [name]: newValue ? newValue.value : null
        }));
    };

    return (
        <>
            <Grid container spacing={4}>
                {[...widgetStructures].sort((a: any, b: any) => (a.name === "Page Structure" ? -1 : b.name === "Page Structure" ? 1 : 0)).map((widget: any) => (
                    <Grid item xs={4} key={widget.shared_uid}>
                        <Box>
                            <Stack flexDirection="row" alignItems="center" mt={2}>
                                <Checkbox
                                    disabled={Boolean(selectedTemplates[widget.name])}
                                    checked={Boolean(selectedTemplates[widget.name])}
                                    color="secondary"
                                />
                                <Autocomplete
                                    sx={{ width: "100%" }}
                                    options={getTemplatesForWidget(widget.name)}
                                    value={getTemplatesForWidget(widget.name)?.find(
                                        (option: any) => option?.value === selectedTemplates[widget.name]
                                    ) || null}
                                    onChange={(_, newValue) => handleTemplateChange(widget.name, newValue)}
                                    getOptionLabel={(option: any) => option?.label || ""}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Please select a Template from the list."
                                            label={widget.name}
                                            InputProps={{
                                                ...params.InputProps,
                                            }}
                                            color="secondary"
                                            required={widget.name === "Page Structure"}
                                        />
                                    )}
                                    size="small"
                                />
                            </Stack>
                            {widget.name === "Page Structure" && (
                                <Typography fontSize={12} marginLeft={"42px"} mt={0.5}>
                                    Mandatory Template
                                </Typography>
                            )}
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </>
    )
}

export default EditAssignedTemplates